import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';
import { useHistory } from 'react-router-dom'; // Importando useHistory para a navegação

function Home4() {
  const history = useHistory(); // Criando uma função de navegação

  const handleNavigation = () => {
    history.push('/servicos'); // Redireciona para a página /services
  };

  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <S.title>
            <h1>ATUAÇÕES DO TRAVESSIAS</h1>
            <hr></hr>
          </S.title>
          <S.TextHorizontal>
            <div>
              <h3>ATENDIMENTO CLÍNICO </h3>
              <hr />
              <p>
                Oferecemos atendimento clínico com profissionais qualificados,
                cuidadosamente selecionados para atender ao perfil e às
                necessidades específicas de cada pessoa.
              </p>
              <button onClick={handleNavigation}>Saiba mais</button>
            </div>
            <div>
              <h3>FORMAÇÃO CONTINUADA</h3>
              <hr />
              <p>
                Promovemos palestras, seminários e grupos de estudo e leitura
                voltados ao aperfeiçoamento profissional contínuo.
              </p>
              <button onClick={handleNavigation}>Saiba mais</button>
            </div>
            <div>
              <h3>DIVERSIDADE TEÓRICA, PRÁTICA E CLÍNICA</h3>
              <hr />
              <p>
                Valorizamos uma formação plural, com autores de diversas
                abordagens dentro do escopo psicanalítico — e também para além
                dele.
              </p>
              <button onClick={handleNavigation}>Saiba mais</button>
            </div>
          </S.TextHorizontal>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home4;
